import React, { useEffect } from 'react';
import AutomaticDrawer from 'components/Drawers/AutomaticDrawer';
import useQueryParams from 'hooks/useQueryParams';
import { snackbar } from 'components/notifications/notifications';
import { useUpdateCustomCostMutation } from 'modules/PnLReportModule/api/customCost.api';
import CustomCostForm from './components/CustomCostForm';
import ninjaApi from 'store/redux/apis';
import { Spin } from 'antd';

const UpdateCustomCostDrawer = (props) => {
  const { searchParams, removeParams } = useQueryParams();
  const { custom_cost_id } = searchParams;
  const [updateCustomCoost, { isLoading }] = useUpdateCustomCostMutation();

  const [fetchCustomCost, { isLoading: fetchLoading, data = {} }] =
    ninjaApi.useLazyCustomCostListQuery();

  useEffect(() => {
    if (custom_cost_id) {
      fetchCustomCost({ filters: { id: custom_cost_id } }).unwrap();
    }
  }, [custom_cost_id]);

  const onSubmit = (data) => {
    updateCustomCoost({ id: custom_cost_id, ...data })
      .unwrap()
      .then((data) => {
        snackbar.success(`${data?.data?.name} updated successfully`);
        removeParams(['custom_cost_id', 'edit']);
      });
  };

  return (
    <AutomaticDrawer size='small' title={`Edit ${data?.data?.name}`} {...props}>
      {fetchLoading ? (
        <Spin size='large' />
      ) : (
        <CustomCostForm
          onSubmit={onSubmit}
          isLoading={isLoading}
          editing={true}
          data={data?.data}
        />
      )}
    </AutomaticDrawer>
  );
};

UpdateCustomCostDrawer.requiredParams = {
  edit: true,
  custom_cost_id: (p) => parseInt(p) > 0,
};

export default UpdateCustomCostDrawer;
